import React from 'react';
import { cn } from '@/lib/utils';
import { fmtMoney } from '@/lib/format';
import { CountUp } from './CountUp';

const VARIANTS = {
  recovered: { bar: 'bg-money', tint: 'from-money-50/60', iconBg: 'bg-money-50', iconFg: 'text-money-700', num: 'text-money-700' },
  at_risk: { bar: 'bg-warn', tint: 'from-warn-50/60', iconBg: 'bg-warn-50', iconFg: 'text-warn-700', num: 'text-warn-700' },
  disputed: { bar: 'bg-danger', tint: 'from-danger-50/60', iconBg: 'bg-danger-50', iconFg: 'text-danger-700', num: 'text-danger-700' },
  neutral: { bar: 'bg-ink-700', tint: 'from-slate-50', iconBg: 'bg-slate-100', iconFg: 'text-ink-700', num: 'text-ink-900' },
  info: { bar: 'bg-brand', tint: 'from-brand-50/70', iconBg: 'bg-brand-50', iconFg: 'text-brand-600', num: 'text-ink-900' },
};

export const KpiTile = ({ label, value, variant = 'neutral', icon: Icon, meta, isMoney = true, testid, suffix }) => {
  const v = VARIANTS[variant] || VARIANTS.neutral;
  return (
    <div
      data-testid={testid}
      className={cn('group relative overflow-hidden rounded-xl bg-white border border-[#ECEEF2] shadow-card p-5 transition-shadow duration-200 hover:shadow-lifted animate-fade-up')}
    >
      <div className={cn('absolute inset-x-0 top-0 h-[3px]', v.bar)} />
      <div className={cn('pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-gradient-to-br to-transparent opacity-60', v.tint)} />
      <div className="relative flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.08em] text-slate-500 font-semibold">{label}</div>
          <div className={cn('mt-2 num-lg text-[28px] sm:text-[32px] leading-none', v.num)}>
            {isMoney
              ? <CountUp value={value} format={(n) => fmtMoney(n)} />
              : (typeof value === 'number'
                  ? <CountUp value={value} format={(n) => `${Math.round(n).toLocaleString()}${suffix || ''}`} />
                  : value)}
          </div>
          {meta && <div className="mt-2 text-xs text-slate-500">{meta}</div>}
        </div>
        {Icon && (
          <div className={cn('shrink-0 rounded-xl p-2.5 transition-transform duration-200 group-hover:scale-105', v.iconBg)}>
            <Icon className={cn('h-5 w-5', v.iconFg)} />
          </div>
        )}
      </div>
    </div>
  );
};
